import { Check2 } from "react-bootstrap-icons";
import type { FormInt, Interrogatory } from "@/briefpoint-client";
import { getFontSize } from "@/lib/utils";
import { Button } from "../ui/button";
import styles from "./ResponsesNavigator.module.scss";

interface ResponsesNavigatorProps {
  interrogatories: Interrogatory[];
  selectedInterrogatories: Set<number>;
  documentStartingNumber: number;
  formIntsMap: Map<string, FormInt> | null;
  onSelect: (id: number) => void;
}

export default function ResponsesNavigator(props: ResponsesNavigatorProps) {
  return (
    <div className={styles.scrollContainer}>
      <div className={styles.responsesGrid}>
        {props.interrogatories.map((item) => {
          // For FROGS, look up the FormInt using the interrogatory.text as the ID
          const formInt = props.formIntsMap?.get(item.text) ?? null;
          const displayNumber =
            formInt?.displayName ??
            props.documentStartingNumber - 1 + item.number;
          const isSelected = props.selectedInterrogatories.has(item.id);
          const fontSize = getFontSize(displayNumber);

          return (
            <div
              data-testid="response-item"
              key={item.id}
              className={styles.responseItem}
            >
              <Button
                variant="outline"
                className={`${styles.responseNumber} ${isSelected ? styles.selected : ""}`}
                style={{ fontSize: `${fontSize}px` }}
                onClick={() => {
                  props.onSelect(item.id);
                }}
              >
                {displayNumber}
              </Button>
              {isSelected && <Check2 className={styles.checkIcon} />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
